var _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOutreachIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24758_20623)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7914 13.9616C13.6855 13.9309 13.5713 13.9607 13.4939 14.0393C13.4166 14.1179 13.3886 14.2325 13.421 14.3379L14.3939 17.4999H17.8002C17.9659 17.4999 18.1002 17.6342 18.1002 17.7999C18.1002 17.9656 17.9659 18.0999 17.8002 18.0999H14.3939L13.421 21.2618C13.3886 21.3672 13.4166 21.4818 13.494 21.5604C13.5713 21.639 13.6856 21.6688 13.7915 21.6381C16.4709 20.8597 18.9592 19.6325 21.1695 18.0434C21.2479 17.987 21.2944 17.8964 21.2944 17.7998C21.2944 17.7032 21.2479 17.6126 21.1695 17.5562C18.9591 15.9672 16.4709 14.74 13.7914 13.9616Z",
    fill: "#344054"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3998 6.4001V14.8001C19.3998 15.7942 18.5939 16.6001 17.5998 16.6001H5.59981C4.60569 16.6001 3.7998 15.7942 3.7998 14.8001V6.4001M19.3998 6.4001C19.3998 5.40599 18.5939 4.6001 17.5998 4.6001H5.5998C4.60569 4.6001 3.7998 5.40598 3.7998 6.4001M19.3998 6.4001V6.59427C19.3998 7.21934 19.0755 7.79965 18.5432 8.12725L12.5432 11.8196C11.9646 12.1756 11.235 12.1756 10.6564 11.8196L4.65643 8.12725C4.12408 7.79965 3.7998 7.21934 3.7998 6.59427V6.4001",
    stroke: "#344054",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24758_20623"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.6,
    height: 9.6,
    fill: "white",
    transform: "translate(12.3999 13)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutreachIcon);
export default __webpack_public_path__ + "static/media/outreach-icon.6ddae25ffccb6f457da4261bbf7d1b44.svg";
export { ForwardRef as ReactComponent };